(() => {
  const setup = (root) => {
    if (root.dataset.gamesReady) return;
    root.dataset.gamesReady = 'true';
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const controller = new AbortController();
    const options = { signal: controller.signal };
    const filters = [...root.querySelectorAll('[data-game-filter]')];
    const cards = [...root.querySelectorAll('[data-game-card]')];
    const count = root.querySelector('[data-game-count]');
    const applyFilter = (value) => {
      if (!['all', 'family', 'friends', 'adults'].includes(value)) value = 'all';
      cards.forEach((card) => { card.hidden = value !== 'all' && card.dataset.gameGroup !== value; });
      filters.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.gameFilter === value)));
      if (count) {
        const visibleCount = cards.filter((card) => !card.hidden).length;
        count.textContent = visibleCount === 1 ? count.dataset.countOne : count.dataset.countTemplate.replace('%count%', visibleCount);
      }
    };
    root.querySelector('[data-game-filters]')?.removeAttribute('hidden');
    filters.forEach((button) => button.addEventListener('click', () => applyFilter(button.dataset.gameFilter), options));
    root.querySelectorAll('[data-filter-link]').forEach((link) => link.addEventListener('click', () => {
      applyFilter(link.dataset.filterLink);
      const target = filters.find((button) => button.dataset.gameFilter === link.dataset.filterLink);
      if (target) setTimeout(() => target.focus({ preventScroll: true }), 0);
    }, options));
    const video = root.querySelector('[data-film-src]');
    const button = root.querySelector('[data-film-toggle]');
    let observer;
    if (video && button && video.dataset.filmSrc) {
      let userPaused = false;
      let inView = true;
      let wantsPlayback = false;
      let loaded = false;
      const start = Math.max(0, Number(video.dataset.filmStart) || 0);
      const end = Number(video.dataset.filmEnd) || Infinity;
      const saveData = Boolean(navigator.connection?.saveData);
      const sync = () => {
        const playing = !video.paused;
        button.querySelector('[data-film-label]').textContent = playing ? button.dataset.pauseLabel : button.dataset.playLabel;
        button.querySelector('[data-film-symbol]').textContent = playing ? 'Ⅱ' : '▶';
      };
      const pause = () => { wantsPlayback = false; video.pause(); sync(); };
      const play = async () => {
        wantsPlayback = true;
        if (!loaded) {
          loaded = true;
          video.src = video.dataset.filmSrc;
          video.load();
        }
        try {
          await video.play();
          if (!wantsPlayback) video.pause();
        } catch (_) {}
        sync();
      };
      video.muted = true;
      video.addEventListener('loadedmetadata', () => {
        if (start < video.duration) video.currentTime = start;
      }, options);
      video.addEventListener('timeupdate', () => {
        if (!video.paused && end > start && video.currentTime >= end) video.currentTime = start;
      }, options);
      video.addEventListener('ended', () => {
        if (!userPaused && inView && !document.hidden) { video.currentTime = start; play(); }
        else sync();
      }, options);
      video.addEventListener('play', sync, options);
      video.addEventListener('pause', sync, options);
      video.addEventListener('error', () => { loaded = false; pause(); }, options);
      button.addEventListener('click', () => {
        if (video.paused) { userPaused = false; play(); }
        else { userPaused = true; pause(); }
      }, options);
      button.hidden = false;
      const allowAuto = () => !reduced.matches && !saveData && !userPaused && !document.hidden;
      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(([entry]) => {
          inView = entry.isIntersecting;
          if (!inView) pause();
          else if (allowAuto()) play();
        }, { threshold: 0.15 });
        observer.observe(video);
      } else if (allowAuto()) play();
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) pause();
        else if (inView && allowAuto()) play();
      }, options);
      reduced.addEventListener('change', () => {
        if (reduced.matches) pause();
        else if (inView && allowAuto()) play();
      }, options);
    }
    root._gamesLandingCleanup = () => { controller.abort(); observer?.disconnect(); video?.pause(); delete root.dataset.gamesReady; };
  };
  const init = (scope) => {
    if (scope.matches?.('[data-games-landing]')) setup(scope);
    scope.querySelectorAll('[data-games-landing]').forEach(setup);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => event.target.querySelectorAll('[data-games-landing]').forEach((root) => root._gamesLandingCleanup?.()));
})();
